export const assujettiKeys = {
  all: ["assujetti"] as const,
  list: (params: Record<string, unknown>) =>
    [...assujettiKeys.all, params] as const,
  details: () => [...assujettiKeys.all, "detail"] as const,
  byMillesimeAndSiren: (millesime: number, siren: string) =>
    [...assujettiKeys.all, { millesime, siren }] as const,
};
